import { getSanityImageUrl } from '@/libs/sanity/client';
import React from 'react';
import { PortableTextWrapper } from '@/components/PortableTextWrapper';
import { PortableTextBlock } from '@sanity/types';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { BlurInDiv } from '@/components/eldora-ui/blur-in-div';
import { BlurInH1 } from '../eldora-ui/blur-in-h1';

type HeroPartnerProps = {
  title?: string;
  subtitle?: string;
  description?:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  image?: any;
};

const HeroPartner = ({
  title,
  subtitle,
  image,
  description,
}: HeroPartnerProps) => {
  return (
    <section
      className={`${
        image ? 'bg-[#3a3a3a]' : 'bg-white'
      } flex max-w-8xl mx-auto mb-4 relative`}
    >
      <div className="w-full flex flex-col lg:flex-row relative overflow-hidden ml-4">
        {/* Text Section */}
        <div className="w-full lg:w-1/2 px-6 py-12 flex flex-col  relative z-10">
          <BlurInH1 className="text-3xl md:text-4xl lg:text-5xl xl:text-5xl !leading-[1.35em] mb-6 text-[#BF984D]">
            {title?.includes('Our Simplicity®') ? (
              <>
                {title.split('Our Simplicity®')[0]}
                <span className="text-white">
                  Our Simplicity®
                  <br />
                </span>
                {title.split('Our Simplicity®')[1]}
              </>
            ) : (
              <span className="whitespace-pre-line">
                {title.replace(/\\n/g, '\n')}
              </span>
            )}
          </BlurInH1>

          {subtitle && (
            <BlurInDiv>
              <h5 className="text-white text-xl mb-2">{subtitle}</h5>
            </BlurInDiv>
          )}

          {description && (
            <BlurInDiv className="mt-2 ml-1 text-lg max-w-[90%] text-white">
              <PortableTextWrapper value={description} textColor="white" />
            </BlurInDiv>
          )}
        </div>

        {/* Image Section */}
        {image && (
          <div className="w-full lg:w-1/2 px-6 py-12 flex items-center justify-center">
            <img
              src={getSanityImageUrl(image)}
              alt="Hero Image"
              className="w-full h-auto object-cover"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroPartner;
